import { checkSingleEmail } from '@xylabs/sdk-coin-js'

import { ContactInfoData } from '../models'
import { InfoWrapper } from './InfoWrapper'

export class ContactInfoWrapper extends InfoWrapper<ContactInfoData> {
  constructor(value?: ContactInfoData) {
    super('contactInfo', value, true)
  }

  public getData() {
    return this.data
  }

  public getSanitizedData() {
    const result = JSON.parse(JSON.stringify(this.data))
    delete result.email
    delete result.lastName
    delete result.firstName
    delete result.phone
    return result
  }

  public setFirstName(value: string) {
    this.data.firstName = value
    this.save()
    return this
  }

  public validateFirstName() {
    if ((this.data.firstName?.length ?? 0) <= 0) {
      return Error('First name may not be empty')
    }
  }

  public setLastName(value: string) {
    this.data.lastName = value
    this.save()
    return this
  }

  public validateLastName() {
    if ((this.data.lastName?.length ?? 0) <= 0) {
      return Error('Last name may not be empty')
    }
  }

  public setEmail(value: string) {
    this.data.email = value
    this.save()
    return this
  }

  public async validateEmail(debounce?: boolean) {
    const { error, suggestedEmail } = await ContactInfoWrapper.validateEmail(this.data.email, debounce)
    this.suggestedEmail = suggestedEmail
    return error
  }

  public setPhone(value: string) {
    this.data.phone = value
    this.save()
    return this
  }

  public validatePhone() {
    if ((this.data.phone?.length ?? 0) <= 0) {
      return Error('Phone name may not be empty')
    }
  }

  public async errors() {
    return [this.validateFirstName(), this.validateLastName(), await this.validateEmail()].filter((item) => item !== undefined) as Error[]
  }

  static async validateEmail(email?: string, debounce?: boolean): Promise<{ error?: Error; suggestedEmail?: string }> {
    if (!email || email.length === 0) {
      return { error: Error('Email may not be empty') }
    }
    if (debounce) {
      try {
        const check = await checkSingleEmail(email)
        if (check.debounce?.send_transactional !== '1') {
          return { error: Error('Email in invalid'), suggestedEmail: check.debounce?.did_you_mean }
        }
      } catch (ex) {
        console.error(ex)
      }
    }
    return {}
  }
}
